import { render, staticRenderFns } from "./DeliverableList.vue?vue&type=template&id=fc75245e&scoped=true&"
import script from "./DeliverableList.vue?vue&type=script&lang=js&"
export * from "./DeliverableList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc75245e",
  null
  
)

export default component.exports